if (!customElements.get('review-cta')) {
  customElements.define(
    'review-cta',
    class ReviewCta extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.onClick = this.onClick.bind(this);
        this.link?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const targetId = (this.link.getAttribute('href') || '').replace('#', '');
        const target = targetId ? document.getElementById(targetId) : null;
        if (target) {
          event.preventDefault();
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
        }
        this.openReviewForm();
      }

      // Judge.me injects its widget after page load, so retry briefly until the
      // "write a review" trigger exists. The revamped widget uses a
      // data-testid button; the classic one uses .jdgm-write-rev-link, which
      // is a show/hide toggle — skip it if the inline form is already open.
      openReviewForm(attempt = 0) {
        const toggle = document.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
        if (toggle) {
          const form = document.querySelector('.jdgm-rev-widg__form');
          if (!form || form.offsetParent === null) toggle.click();
          return;
        }
        if (attempt < 20) setTimeout(() => this.openReviewForm(attempt + 1), 250);
      }
    }
  );
}
